<page-title [title]="titles[0]"></page-title>
<p>Mantenha seus dados atualizados.</p>

<page-alert *ngIf="alerts.length > 0 && showWarningMessage" [message]="messageWarning">
</page-alert>

<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Perfil">
    <ng-template matTabContent>
      <app-practitioner-registration
        mode="UPDATE"
        (onUpdatePractitioner)="setPractitioner($event)"
       >
      </app-practitioner-registration>
    </ng-template>
  </mat-tab>

  <mat-tab label="Especialidades" [disabled]="checkIfIsFirstAccess()">
    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAccess() ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Especialidades
      </span>
    </ng-template>
    <page-practitioner-practitionerrole-form mode="UPDATE" (onUpdatePractitionerRole)="setPractitionerRole($event)"></page-practitioner-practitionerrole-form>
  </mat-tab>

  <mat-tab label="Qualificações" [disabled]="checkIfIsFirstAccess()">
    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAccess() ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Qualificações
      </span>
    </ng-template>
    <ng-template matTabContent>
      <page-practitioner-qualification-form (onUpdatePractitioner)="setPractitioner($event)" mode="UPDATE"></page-practitioner-qualification-form>
    </ng-template>
  </mat-tab>

  <mat-tab label="Localização" [disabled]="checkIfIsFirstAccess()">

    <ng-template mat-tab-label>
      <span [matTooltip]="checkIfIsFirstAccess() ? 'Complete o cadastro do perfil para liberar esta aba' : ''">
        Localização
      </span>
    </ng-template>
    <ng-template matTabContent>
      <page-practitioner-map mode="UPDATE" (onUpdatePractitioner)="setPractitioner($event)"></page-practitioner-map>
    </ng-template>
  </mat-tab>
</mat-tab-group>